<template>
    <div class="lc">
        <div class="lt-left">
            <p>{{ total }}</p>
            <p v-if="defaultdata[0].value3">{{ defaultdata[0].value3 }}</p>
        </div>
        <div ref="cmain1" class="cmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope127",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            title: 'template.scope127-饼图9',
            timer: null,
            defaultdata: [
                { value1: '数据一', value2: '1700', value3: '总数' },
                { value1: '数据二', value2: '580' },
                { value1: '数据三', value2: '1800' },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "数值", key: "value2" },
                { name: "总计名称", key: "value3" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            autoTimePaused: false,
            total: 0
        }
    },

    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
            this.cDrawCircle();
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null
    },
    methods: {
        ...methods,
        cDrawCircle() {
            clearInterval(this.timer)
            this.timer = null
            var echarts = require('echarts');
            var TmyChart = echarts.init(this.$refs.cmain1);
            const colorList = ['#004cc8', '#fff', '#00d9ff']
            let vdata = JSON.parse(JSON.stringify(this.defaultdata))
            if (vdata.length > 6) {
                vdata = vdata.slice(0, 6)
                this.$message.warning('该饼图最多支持六组数据，超出部分已隐藏')
            }
            this.total = 0
            let data = vdata.map((item, i) => {
                this.total += +item.value2
                if (item.value1 && (item.value2 || item.value2 == 0)) {
                    return {
                        name: item.value1,
                        value: +item.value2,
                        itemStyle: {
                            color: colorList[i]
                        }
                    }
                }
            })
            let total = 0
            data.forEach(item => {
                if (item && item.value) {
                    total += item.value
                }
            })
            var Toption = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',  //文字 行 排放 默认列
                    top: 'middle',
                    right: 50,
                    itemHeight: 15,    //图例的高度  文字左边那个
                    itemWidth: 15,
                    z: 5,
                    textStyle: {
                        //设置文本样式
                        color: "#CBD8DE",
                        lineHeight: 24,
                        fontWeight: '400',
                        fontSize: '14',
                        // padding: [0, 0, 0, 10],
                        rich: {
                            a: {
                                width: 60,
                                padding: [0, -5, 0, 5],
                                fontSize: 14,
                            },
                            b: {
                                padding: [0, 0, 0, 28],
                                fontSize: 14,
                                color: '#00D9FF'
                            },
                        }

                    },         //图例的高度
                    formatter: function (name) {
                        let newName = name.length > 4 ? name.slice(0, 4) + '...' : name;
                        const format = data.find(item => item.name == name)
                        let percent = (format.value / total * 100).toFixed(2)
                        let arr = [
                            '{a|' + newName + '}',
                        ]
                        return arr
                    }
                },
                series: [
                    {
                        type: 'pie',
                        //选中ple的中间40-50
                        center: ['28%', '52%'],
                        radius: ['65%', '78%'],
                        label: {
                            show: false,
                            position: 'center'
                        },
                        itemStyle: {
                            normal: {
                                borderColor: '#000',
                                borderWidth: 2,
                            }
                        },
                        data: data,
                    }
                ]
            };
            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(function () {
                if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000)
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.cDrawCircle()
    },
};
</script>

<style scoped lang="scss">
.lc {
    width: 435px;
    height: 240px;
    display: flex;
    position: relative;
    padding: 10px 0;
}

.lt-left {
    width: 240px;
    height: 179px;
    position: absolute;
    left: calc(50% - 215px);
    top: calc(50% - 86px);
    box-sizing: border-box;
    background: url('@/assets/temimg4/piebg7.png') no-repeat;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    p {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 28px;
        color: #FFFFFF;
        line-height: 28px;
        max-width: 148px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        
        &+p {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #BDC7CC;
            line-height: 14px;
            margin-top: 14px;
        }
    }
}

.cmain {
    width: 100%;
    height: 100%;
}
</style>